import {integrationValidatorModule} from "./integrationValidatorModule";
import {IntegrationValidatorService} from "./integrationValidatorService";
import {LoadingService, MessagesModal, RemoteExceptionHandler} from "front-end-web-commons/app/index.d.ts";
import {ExceptionModal} from "./exceptionModal";
import {IntegrationValidatorResult} from "./integrationValidatorResult";

export class NlgIntegrationValidatorController {
    private integrationDataSource: string = "";
    private integrationInterfaceName: string = "";

    constructor(private integrationValidatorService: IntegrationValidatorService,
                private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private exceptionModal: ExceptionModal) {
        this.getIntegrationDataSources().then(dataSources => this.integrationDataSource = dataSources[0])
    }

    getIntegrationDataSources() {
        return this.integrationValidatorService.getIntegrationDataSources()
    }

    getAvailableInterfaces() {
        return this.integrationValidatorService.getAvailableInterfaces()
    }

    testPublish() {
        return this.loadingService(this.integrationValidatorService.testPublish(this.integrationInterfaceName, this.integrationDataSource))
            .catch(this.remoteExceptionHandler())
            .then((result: IntegrationValidatorResult) => {
                if (result.successful) {
                    return this.messagesModal("dialog.success", "integration.connectivity.ok")
                }
                return this.exceptionModal.open(result.throwable)
            })
    }
}

integrationValidatorModule.directive("nlgIntegrationValidator", function () {
    return {
        controller: NlgIntegrationValidatorController,
        controllerAs: "ctrl",
        // @ts-ignore
        templateUrl: require("link!./nlgIntegrationValidator.html")
    }
})